import styled from "styled-components";
import { fontFamilies, fontSizes } from "components/shared/tokens/typography";
import { zSpacing } from "components/shared/tokens/spacing";
import red from "components/shared/tokens/color/red";
import grey from "components/shared/tokens/color/grey";
import box from "components/shared/tokens/box";

const DARK_NAVY = "#293142";

export const ProfileContainer = styled.div`
  width: 100%;
  height: 100vh;
  background: #f2f4f9;
  font-family: ${fontFamilies.regular};
  display: flex;
  justify-content: center;
`;

export const ScrollArea = styled.div`
  width: 100%;
  max-width: 640px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
`;

export const TopProfileCard = styled.div`
  background: #ffffff;
  border-radius: 0 0 24px 24px;
  padding: ${zSpacing.z4} ${zSpacing.z3} ${zSpacing.z5} ${zSpacing.z3};
  box-shadow: ${box.shadow.z4};
`;

export const HeaderBar = styled.div`
  display: flex;
  align-items: center;
  font-size: ${fontSizes.z400};
  font-weight: 600;
  color: ${DARK_NAVY};
  cursor: pointer;
  font-family: ${fontFamilies.semiBold};

  span {
    margin-left: ${zSpacing.z3};
  }
`;

export const SmallText = styled.div`
  font-size: ${fontSizes.z200};
  line-height: 1.2;
  color: ${grey.z500};
  margin-bottom: ${zSpacing.z1};
  font-family: ${fontFamilies.regular};
`;

export const FieldValue = styled.div`
  font-size: ${fontSizes.z300};
  color: ${DARK_NAVY};
  font-weight: 600;
  line-height: 1.4;
  font-family: ${fontFamilies.semiBold};
`;

export const SectionHeading = styled.div`
  font-size: ${fontSizes.z200};
  font-weight: 600;
  color: ${grey.z500};
  letter-spacing: 0.08em;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${zSpacing.z3};
  margin: ${zSpacing.z4} 0 ${zSpacing.z3} 0;
  font-family: ${fontFamilies.semiBold};
`;

export const OutletList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${zSpacing.z3};
`;

export const OutletCard = styled.div`
  background: #ffffff;
  border-radius: 16px;
  padding: ${zSpacing.z3};
  display: flex;
  flex-direction: column;
  gap: ${zSpacing.z1};
`;

export const OutletTitle = styled.div`
  font-size: ${fontSizes.z300};
  font-weight: 700;
  color: ${DARK_NAVY};
  font-family: ${fontFamilies.bold};
  overflow-wrap: break-word;
`;

export const OutletAddress = styled.div`
  font-size: ${fontSizes.z200};
  color: ${grey.z500};
  line-height: 1.4;
  font-family: ${fontFamilies.regular};
  overflow-wrap: break-word;
`;

export const OutlineActionButton = styled.button`
  width: 100%;
  border: 1px solid ${grey.z200};
  background: #ffffff;
  border-radius: 16px;
  padding: ${zSpacing.z3};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${fontSizes.z300};
  font-weight: 600;
  color: ${red.z500};
  font-family: ${fontFamilies.semiBold};
  transition: background 0.2s ease-in-out;

  &:active {
    background: ${grey.z95};
  }
`;

export const ActionButtonContent = styled.div`
  display: flex;
  align-items: center;
  gap: ${zSpacing.z2};
`;

export const IconWrapper = styled.div`
  display: inline-flex;
  width: 20px;
  height: 20px;
  justify-content: center;
  align-items: center;
`;